import Inputmask from 'inputmask';

export const CardNumberMixin = {
    methods: {
        addCreditCardMask(ref) {
            Inputmask({
                mask: '9999 9999 9999 9999',
                showMaskOnHover: true,
                placeholder: ' '
            }).mask(ref);
        },
    }
};


// WEBPACK FOOTER //
// ./src/mixins/CardNumberMixin.js